/* eslint-disable */
export default {
  _a: 'a',
  _about: 'about',
  _after: 'after',
  _again: 'again',
  _all_words: 'all_words',
  _all: 'all',
  _always: 'always',
  _am: 'am',
  _an: 'an',
  _and: 'and',
  _any: 'any',
  _are: 'are',
  _around: 'around',
  _as: 'as',
  _ask: 'ask',
  _at: 'at',
  _ate: 'ate',
  _away: 'away',
  _b: 'b',
  _be: 'be',
  _because: 'because',
  _been: 'been',
  _before: 'before',
  _best: 'best',
  _better: 'better',
  _big: 'big',
  _black: 'black',
  _blue: 'blue',
  _both: 'both',
  _bring: 'bring',
  _brown: 'brown',
  _but: 'but',
  _buy: 'buy',
  _by: 'by',
  _c: 'c',
  _call: 'call',
  _came: 'came',
  _can: 'can',
  _carry: 'carry',
  _clean: 'clean',
  _cold: 'cold',
  _come: 'come',
  _could: 'could',
  _cut: 'cut',
  _d: 'd',
  _did: 'did',
  _do: 'do',
  _does: 'does',
  _don_t: 'don\'t',
  _done: 'done',
  _down: 'down',
  _draw: 'draw',
  _drink: 'drink',
  _e: 'e',
  _eat: 'eat',
  _eight: 'eight',
  _every: 'every',
  _f: 'f',
  _fall: 'fall',
  _far: 'far',
  _fast: 'fast',
  _find: 'find',
  _first_grade: 'first_grade',
  _first: 'first',
  _five: 'five',
  _fly: 'fly',
  _for: 'for',
  _found: 'found',
  _four: 'four',
  _from: 'from',
  _full: 'full',
  _funny: 'funny',
  _g: 'g',
  _gave: 'gave',
  _get: 'get',
  _give: 'give',
  _go: 'go',
  _goes: 'goes',
  _going: 'going',
  _good: 'good',
  _got: 'got',
  _great_job_you_found_the_treasure: 'great_job_you_found_the_treasure',
  _green: 'green',
  _grow: 'grow',
  _h: 'h',
  _had: 'had',
  _has: 'has',
  _have: 'have',
  _he: 'he',
  _help: 'help',
  _her: 'her',
  _here: 'here',
  _him: 'him',
  _his: 'his',
  _hold: 'hold',
  _hot: 'hot',
  _how: 'how',
  _hurt: 'hurt',
  _i: 'i',
  _if: 'if',
  _in: 'in',
  _into: 'into',
  _Intro_Favorite: 'Intro_Favorite',
  _is: 'is',
  _it: 'it',
  _its: 'its',
  _j: 'j',
  _jump: 'jump',
  _just: 'just',
  _k: 'k',
  _keep: 'keep',
  _kind: 'kind',
  _know: 'know',
  _l: 'l',
  _laugh: 'laugh',
  _let: 'let',
  _light: 'light',
  _like: 'like',
  _little: 'little',
  _live: 'live',
  _long: 'long',
  _look: 'look',
  _m: 'm',
  _made: 'made',
  _make: 'make',
  _many: 'many',
  _may: 'may',
  _me: 'me',
  _much: 'much',
  _must: 'must',
  _my: 'my',
  _myself: 'myself',
  _n: 'n',
  _never: 'never',
  _new: 'new',
  _no: 'no',
  _not: 'not',
  _now: 'now',
  _o: 'o',
  _Octopus: 'Octopus',
  _of: 'of',
  _off: 'off',
  _old: 'old',
  _on: 'on',
  _once: 'once',
  _one: 'one',
  _only: 'only',
  _open: 'open',
  _or: 'or',
  _our: 'our',
  _out: 'out',
  _over: 'over',
  _own: 'own',
  _p: 'p',
  _pick: 'pick',
  _play: 'play',
  _please: 'please',
  _pre_primer: 'pre_primer',
  _pretty: 'pretty',
  _primer: 'primer',
  _pull: 'pull',
  _put: 'put',
  _q: 'q',
  _r: 'r',
  _ran: 'ran',
  _read: 'read',
  _red: 'red',
  _ride: 'ride',
  _right: 'right',
  _round: 'round',
  _run: 'run',
  _s: 's',
  _said: 'said',
  _saw: 'saw',
  _say: 'say',
  _second_grade: 'second_grade',
  _see: 'see',
  _Select_A_Level: 'Select_A_Level',
  _seven: 'seven',
  _shall: 'shall',
  _she: 'she',
  _show: 'show',
  _sing: 'sing',
  _sit: 'sit',
  _six: 'six',
  _sleep: 'sleep',
  _small: 'small',
  _so: 'so',
  _some: 'some',
  _soon: 'soon',
  _start: 'start',
  _stop: 'stop',
  _t: 't',
  _take: 'take',
  _tell: 'tell',
  _ten: 'ten',
  _thank: 'thank',
  _that: 'that',
  _the: 'the',
  _their: 'their',
  _them: 'them',
  _then: 'then',
  _there: 'there',
  _these: 'these',
  _they: 'they',
  _think: 'think',
  _third_grade: 'third_grade',
  _this: 'this',
  _those: 'those',
  _three: 'three',
  _to: 'to',
  _today: 'today',
  _together: 'together',
  _too: 'too',
  _try: 'try',
  _turn_sound_on: 'turn_sound_on',
  _two: 'two',
  _u: 'u',
  _under: 'under',
  _up: 'up',
  _upon: 'upon',
  _us: 'us',
  _use: 'use',
  _v: 'v',
  _very: 'very',
  _w: 'w',
  _walk: 'walk',
  _want: 'want',
  _warm: 'warm',
  _was: 'was',
  _wash: 'wash',
  _we: 'we',
  _well: 'well',
  _went: 'went',
  _were: 'were',
  _what: 'what',
  _when: 'when',
  _where: 'where',
  _which: 'which',
  _white: 'white',
  _who: 'who',
  _why: 'why',
  _will: 'will',
  _wish: 'wish',
  _with: 'with',
  _work: 'work',
  _would: 'would',
  _write: 'write',
  _x: 'x',
  _y: 'y',
  _yellow: 'yellow',
  _yes: 'yes',
  _you: 'you',
  _your: 'your',
  _z: 'z',
  _apple: 'apple',
  _baby: 'baby',
  _back: 'back',
  _ball: 'ball',
  _bear: 'bear',
  _bed: 'bed',
  _bell: 'bell',
  _bird: 'bird',
  _birthday: 'birthday',
  _boat: 'boat',
  _box: 'box',
  _boy: 'boy',
  _bread: 'bread',
  _brother: 'brother',
  _cake: 'cake',
  _car: 'car',
  _cat: 'cat',
  _chair: 'chair',
  _chicken: 'chicken',
  _children: 'children',
  _Christmas: 'Christmas',
  _coat: 'coat',
  _corn: 'corn',
  _cow: 'cow',
  _day: 'day',
  _dog: 'dog',
  _doll: 'doll',
  _door: 'door',
  _duck: 'duck',
  _egg: 'egg',
  _eye: 'eye',
  _farm: 'farm',
  _farmer: 'farmer',
  _father: 'father',
  _feet: 'feet',
  _fire: 'fire',
  _fish: 'fish',
  _floor: 'floor',
  _flower: 'flower',
  _game: 'game',
  _garden: 'garden',
  _girl: 'girl',
  _goodbye: 'goodbye',
  _grass: 'grass',
  _ground: 'ground',
  _hand: 'hand',
  _head: 'head',
  _hill: 'hill',
  _home: 'home',
  _horse: 'horse',
  _house: 'house',
  _kitty: 'kitty',
  _leg: 'leg',
  _letter: 'letter',
  _man: 'man',
  _men: 'men',
  _milk: 'milk',
  _money: 'money',
  _morning: 'morning',
  _mother: 'mother',
  _name: 'name',
  _nest: 'nest',
  _night: 'night',
  _paper: 'paper',
  _party: 'party',
  _picture: 'picture',
  _pig: 'pig',
  _rabbit: 'rabbit',
  _rain: 'rain',
  _robin: 'robin',
  _sheep: 'sheep',
  _shoe: 'shoe',
  _sister: 'sister',
  _snow: 'snow',
  _song: 'song',
  _squirrel: 'squirrel',
  _stick: 'stick',
  _street: 'street',
  _sun: 'sun',
  _table: 'table',
  _thing: 'thing',
  _time: 'time',
  _top: 'top',
  _toy: 'toy',
  _tree: 'tree',
  _watch: 'watch',
  _water: 'water',
  _way: 'way',
  _wind: 'wind',
  _window: 'window',
  _wood: 'wood',
}